import request from '@/utils/httpRequest'

export default class MarchIntoService {
    queryById (id) {
		return request({
		  url: '/shye/customer/bunkMarch/queryMarchById',
		  method: 'get',
		  params: {id: id}
		});
    }

    startFlow (params) {
		return request({
		  url: '/shye/customer/bunkMarch/startMarchFlow',
		  method: 'post',
		  data: params
		})
    }
}
